export const user = {
  state: () => ({
    location: "Romania",
    //currency: "USD",
  }),
  mutations: {},
  actions: {},
  getters: {},
};
